import firebase from "firebase";
import "firebase/firestore";

const config = {
    apiKey: "AIzaSyAIBy-H_w3KK1E2VuU-SMVzo6JZa3Oz3KM",
    authDomain: "facilita-juridico.firebaseapp.com",
    projectId: "facilita-juridico",
    storageBucket: "facilita-juridico.appspot.com",
    messagingSenderId: "341850929881",
    appId: "1:341850929881:web:de8cfc841c065d6de61cc8",
    measurementId: "G-SS4YCML6XS"
};

const app = firebase.initializeApp(config);

const getCollection = (collection) =>
    app.firestore().collection(collection);

export const getDocByCollection = (collection, doc, callback) =>
    getCollection(collection).doc(`${doc}`)
        .onSnapshot({ includeMetadataChanges: true }, callback)

export const removeDocFromCollection = (collection, doc) =>
    getCollection(collection)
        .doc(`${doc}`).delete()
        .catch((error) => console.error("Erro exclusão document firebase: ", error));
